// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__LT-dg","overflowing":"ReadFullNote_overflowing__8x4-Z"};